import ParkingCreate from '@/components/parking/ParkingCreate'
import ParkingEdit from '@/components/parking/ParkingEdit'

export default [
  {
    path: '/parkings/creation',
    name: 'ParkingCreate',
    component: ParkingCreate,
    meta: {
      parentName: 'StockParkings',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  },
  {
    path: '/parkings/:id/edition',
    name: 'ParkingEdit',
    component: ParkingEdit,
    meta: {
      parentName: 'LotVue',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/parkingRouter.js